import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';
import { useTimer } from 'services/timer/TimerContext';

interface TimerStartFormProps {
    viewKey?: string;
    ticketId?: number; // Links the started timer to a ticket when given
    onStarted?: () => void;
}

// The form to start a timer with a time type, project and note
const TimerStartForm: React.FC<TimerStartFormProps> = ({ viewKey, ticketId, onStarted }) => {
    const { setRunningTimer } = useTimer();

    // The fields of the start form
    const fields: FieldType[] = [
        {
            type: 'dropdown',
            name: 'time_type',
            label: 'timerow.general.type_label',
            apiRequest: [{
                endpoint: 'get_timesheet_timetype_list',
                object: 'timesheet_timetype',
                params: { is_active: true },
                useCache: true
            }],
            disabled_selected: 'timerow.general.type_disabled_selected',
            allowNoneOption: false,
            showSearch: false,
        },
        {
            type: 'searchselect',
            name: 'project',
            label: 'timerow.general.project_label',
            placeholder: 'job.general.project_placeholder',
            objectName: 'timerow.general.object_name.singular',
            query: { endpoint: 'get_project_search' },
            activeFeature: 'projects',
            disableAddNew: true,
            selectionFormat: 'name',
            optionFormat: {
                title: { field: 'name', format: (value) => value },
                subtitle: { field: 'number', format: (value) => value, optional: true },
            },
        },
        {
            type: 'textarea',
            name: 'note',
            label: 'timerow.general.note_label',
            rows: 3,
            isNote: true,
            placeholder: 'timerow.general.note_placeholder',
        },
    ];

    // Store the started timer in the timer context
    const handleSuccess = (response?: Record<string, any>) => {
        if (response?.running_timer) setRunningTimer(response.running_timer);
        if (onStarted) onStarted();
    };

    return (
        <FormModal
            viewKey={viewKey}
            apiObject='start_timerow'
            fields={fields}
            linkedItem={ticketId ? { ticket: ticketId } : undefined}
            primaryButtonLabel='timerow.timer.start_button_label'
            onSuccess={handleSuccess}
        />
    );
};

export default TimerStartForm;
